<template>
  <div id="say-trip">
    <TravelSpecialistCard v-if="isOpen" @open="openSpecialistModal" />
    <main v-if="ready">
      <section v-if="loadError" class="max-w-screen-xl mx-auto px-4 py-20 text-center">
        <h1 class="font-secondary text-2xl md:text-3xl mb-4">{{ tr('Itinerary not found') }}</h1>
        <p class="text-dark-gray">{{ tr('The selected group itinerary is not available.') }}</p>
      </section>
      <template v-else>
      <!-- <ExpiredPage v-if="isExpired"></ExpiredPage> -->
      <!-- <template v-else> -->
        <Header v-if="isOpen" :show-designed-for="false"></Header>
        <SectionWhy v-if="isOpen"></SectionWhy>
        <OverviewGroup v-if="isOpen"></OverviewGroup>
        <GroupTravelers v-if="isOpen && !isPersonalized"></GroupTravelers>
        <DayListGroup v-if="isOpen && isPersonalized"></DayListGroup>
        <PricingGroup bookingType="GROUPS" v-if="isOpen && isPersonalized"></PricingGroup>
        <NextSteps bookingType="GROUPS" :viewOnlyInQuote="viewOnlyInQuote" v-if="!isCancelled && !isClosed"></NextSteps>
        <CarbonNeutral v-if="isOpen"></CarbonNeutral>
        <FAQsGroup v-if="viewOnlyInQuote"></FAQsGroup>
        <ClosedText v-if="isClosed"></ClosedText>
        <CancelPage v-if="isCancelled"></CancelPage>
        <Footer></Footer>
      </template>
      <!-- </template> -->
      <TravelSpecialistModal :show="showModal" @close="closeModal" />

    </main>
    <Transition>
        <BlockUI v-if="!ready"></BlockUI>
    </Transition>
    <VamoosButton v-if="isUser" :groups="true"/>
  </div>
</template>

<script>
import Header from '@/components/itinerary/Header.vue';
import SectionWhy from '@/components/itinerary/SectionWhy.vue';
import OverviewGroup from '@/components/itinerary/OverviewGroup.vue';
import GroupTravelers from '@/components/itinerary/GroupTravelers.vue';
import DayListGroup from '@/components/itinerary/DayListGroup.vue';
import PricingGroup from '@/components/itinerary/PricingGroup.vue';
import NextSteps from '@/components/itinerary/NextSteps.vue';
import CarbonNeutral from '@/components/itinerary/CarbonNeutral.vue';
import FAQsGroup from '@/components/itinerary/FAQsGroup.vue';
import BlockUI from '@/components/tools/BlockUI.vue';
import Footer from '@/components/tools/Footer.vue';
import ClosedText from '../itinerary/ClosedText.vue';
import CancelPage from '../itinerary/CancelPage.vue';
import VamoosButton from '@/components/tools/VamoosButton.vue';
import TravelSpecialistCard from '@/components/itinerary/TravelSpecialistCard.vue';
import TravelSpecialistModal from '@/components/itinerary/TravelSpecialistModal.vue';
import BaseItineraryPage from '@/components/pages/BaseItineraryPage.vue';
// import ExpiredPage from '../itinerary/ExpiredPage.vue';
import '@/assets/css/main.scss';
const api = window.api;
export default {
  name: 'SayGroups',
  extends: BaseItineraryPage,
  data() {
    return {
      loadError: false,
    }
  },
  computed: {
    isPersonalized() {
      return Boolean(this.$route.params.name);
    }
  },
  async mounted() {
    const params = {
      ...this.$route.query,
      ...(this.$route.params.name ? { name: this.$route.params.name } : {}),
    };
    const endpoint = (legacy, personalized) => this.isPersonalized ? personalized : legacy;

    api.get(endpoint('/api/groups/group_seller_db', '/api/groups/itinerary_seller_db'), params, null, (r) => {
        if (r) {
          this.$store.commit('setSeller', r);
        }
    });
    let res;
    try {
      res = await api.get(endpoint('/api/groups/group_booking', '/api/groups/itinerary_booking'), params);
    } catch (error) {
      this.loadError = true;
    }
    if (Array.isArray(res) && res.length) {
      this.$store.commit('setDateView', res[0]?.ANALYSIS2);
      api.get(endpoint('/api/groups/group_replace_notes', '/api/groups/itinerary_replace_notes'), params, null, (result) => {
        this.$store.commit('setReplaceNotes', result);
      });
      this.$store.commit('setAgent', res?.[0]?.agent);
      api.get(endpoint('/api/groups/group_cover', '/api/groups/itinerary_cover'), params, null, (result) => {
        this.$store.commit('setNames', {values: result, isPCM: false});
      });
      api.get(endpoint('/api/groups/group_hotel_painting', '/api/groups/itinerary_hotel_painting'), params, null, (result) => {
        this.$store.commit('setGroupHotelPainting', result);
      });
      this.$store.commit('setFITBooking', res);
      api.get(endpoint('/api/groups/group_client_image', '/api/groups/itinerary_client_image'), params, null, (result) => {
        this.$store.commit('setClientImage', result);
      });
      api.get(endpoint('/api/groups/group_passengers', '/api/groups/itinerary_passengers'), params, null, (result) => {
        this.$store.commit('setGroupPassengers', result);
        this.$store.commit('setPaxPrincipal', result);
      });
      this.$store.commit('setQuery', params);
      this.status = res[0]?.Status;
      const showPrices = res[0]?.MostrarPrecios?.trim().toUpperCase() == 'SI'
        && res[0]?.Status == 'Quote';
      this.$store.commit('setHidePrices', !showPrices);
      api.get(endpoint('/api/groups/group_prices', '/api/groups/itinerary_prices'), params, null, (result) => {
        const pricesByItinerary = (result || []).map((row) => {
          const paxCount = Number(row.TOTALPAX) || 0;
          return {
            PaxName: (row.Itinerary || '').trim(),
            PriceTotal: paxCount > 0 ? (Number(row.PriceTotal) || 0) / paxCount : 0,
            PaxCount: paxCount,
          };
        });
        const principal = pricesByItinerary.find(
          (price) => price.PaxName.toUpperCase() === 'PRINCIPAL'
        );
        const principalPrice = principal?.PriceTotal || 0;
        let groupPrices = pricesByItinerary.map((price) => ({
          ...price,
          PriceTotal: price.PaxName.toUpperCase() === 'PRINCIPAL'
            ? price.PriceTotal
            : price.PriceTotal + principalPrice,
        }));
        if (this.isPersonalized) {
          const selectedName = (this.$route.params.name || '').trim().toUpperCase();
          groupPrices = groupPrices.filter(
            (price) => price.PaxName.toUpperCase() === selectedName
          );
        }
        this.$store.commit('setGroupPrices', groupPrices);
      });
      if (this.isPersonalized) {
        api.get('/api/groups/itinerary_price_details', params, null, (result) => {
          this.$store.commit('setFITPriceDetails', result);
        });
      }
      if(res[0]?.GR.trim()) {
        api.get(`/api/tpsql/user_by_gr/${res[0].GR}`, params, null, (res) => {
          this.$store.commit('setGrUser', res);
        })
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    } else {
      this.loadError = this.isPersonalized;
      this.loading = false;
    }
    api.get(endpoint('/api/groups/group_flights', '/api/groups/itinerary_flights'), params, null, (result) => {
      this.$store.commit('setFlights', result);
    });
    api.get(endpoint('/api/groups/group_language_notes', '/api/groups/itinerary_language_notes'), params, null, (r) => {
      this.$store.commit('setLanguageNotes', r);
      setTimeout(() => {
        this.loadingNotes = false;
      }, 1000);
    });
    api.get(`/api/bookingcc_ref/${this.$route.query.Code}`, this.$route.query, null, (result) => {
      this.$store.commit('setCurrencyRate', result);
    });
    api.get(`/api/bookingexpired_ref/${this.$route.query.Code}`, this.$route.query, null, (result) => {
      this.expiredDays = result?.DaysToExpire || null;
    });
    api.get("/api/bookingexpireddefault/", null, null, (res) => {
      if (res) {
        this.expiredDaysDefault = res.DaysToExpire;
      }
    });

  },
  components: {
    Header,
    SectionWhy,
    OverviewGroup,
    GroupTravelers,
    DayListGroup,
    PricingGroup,
    NextSteps,
    CarbonNeutral,
    FAQsGroup,
    BlockUI,
    Footer,
    ClosedText,
    CancelPage,
    VamoosButton,
    TravelSpecialistCard,
    TravelSpecialistModal,
    // ExpiredPage,
  }
}
</script>

<style scoped>
.trip-body {
  overflow: scroll;
}

.v-leave-active {
  transition: opacity 1s ease;
}


.v-leave-to {
  opacity: 0;
}
</style>
